import {EventBus} from '@/main';

export function displayAlert(message: string) {
    EventBus.$emit('show-snackbar', message);
}
